module.exports = "https://mrkt.spotifycdn.com/artists-spotify-com/_next/static/images/footer-ios-a77e2676a3ffba2c521ce743a6d82eea.svg";